<template>
    <div
        id="app"
        class="antialiased"
    >
        <ConfigProvider
            v-if="$route.name"
            :locale="locale"
        >
            <Component :is="layout">
                <RouterView />
            </Component>
        </ConfigProvider>
    </div>
</template>
<script>
import { ConfigProvider } from 'ant-design-vue';
import nl from 'ant-design-vue/lib/locale-provider/nl_NL';

import Authenticated from '@/layouts/Authenticated.vue';
import Unauthenticated from '@/layouts/Unauthenticated.vue';

export default {
    components: {
        ConfigProvider,
        Authenticated,
        Unauthenticated,
    },
    data: () => ({
        locale: nl,
    }),
    computed: {
        layout() {
            return this.$route.meta.layout || 'Authenticated';
        },
    },
};
</script>
<style lang="postcss">

@tailwind base;
@tailwind components;
@tailwind utilities;


/* Fixes the position of the anticons */
.anticon {
    vertical-align: 0.125em !important;
}

/* Fixes the spacing of sider items */
.ant-menu-item {
    margin-top: 0 !important;
}

/* Fixes the height for the header */
.ant-breadcrumb {
    line-height: 64px !important;
}

/* Fixes empty icon to center it */
.ant-empty img{
    display: initial;
}

/* Adds a border to the table */
.ant-table td, .ant-table th {
    border: 1px solid #e8e8e8;
}

h1 {
    @apply text-lg font-bold tracking-wider text-gray-800
}

.vue-portal-target.header-actions  > *:not(:last-child) {
    @apply mr-2
}

</style>
